import type { DeliveryZoneResponse } from '../api/delivery-zones.js'

// Legacy 10-entry palette kept for backward compatibility / explicit swatch use.
// New zone colors are generated via golden-angle hue to avoid collisions across
// realistic zone counts (a 10-entry modulo palette collides ~50% at 4 zones).
export const ZONE_PALETTE = [
  '#3b82f6', '#ef4444', '#22c55e', '#f59e0b', '#8b5cf6',
  '#06b6d4', '#ec4899', '#84cc16', '#f97316', '#6366f1',
]

// Deterministic, stable per zone id. Golden-angle spread across the hue wheel
// keeps distinct ids visually distinct; deleting/adding zones does not shift the
// color assigned to any other zone (hash of the id, not array index).
export function zoneColor(id: string): string {
  let h = 0
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0
  const hue = (h * 137.508) % 360
  return `hsl(${Math.round(hue)}, 65%, 55%)`
}

export const DEFAULT_ZONE_COLOR = '#3b82f6'

export function makeZoneFeature(zone: DeliveryZoneResponse): GeoJSON.Feature {
  return {
    type: 'Feature',
    id: `zone-${zone.id}`,
    properties: {
      zoneId: zone.id,
      name: zone.name,
      isActive: zone.isActive,
      mode: 'static',
      color: zoneColor(zone.id),
    },
    geometry: zone.geometry,
  }
}
